const QUEUE_KEY = 'beatq.merchant.floorWriteQueue.v1';

export type FloorWriteKind =
  | 'start_prep'
  | 'flag_delay'
  | 'bump_item'
  | 'recall_ticket'
  | 'pick_item'
  | 'mark_unavailable'
  | 'record_weight'
  | 'propose_substitution'
  | 'complete_pick'
  | 'verify_collection'
  | 'complete_handover'
  | 'refuse_handover'
  | 'record_age_check'
  | 'mark_ready'
  | 'override_gate';

export type FloorWriteItem = {
  id: string;
  kind: FloorWriteKind;
  label: string;
  orderId?: string;
  itemId?: string;
  payload: Record<string, unknown>;
  status: 'pending' | 'failed' | 'synced';
  createdAt: string;
  retryCount: number;
};

export function loadFloorWriteQueue(): FloorWriteItem[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as FloorWriteItem[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveFloorWriteQueue(items: FloorWriteItem[]): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(QUEUE_KEY, JSON.stringify(items.slice(0, 60)));
}

export function enqueueFloorWrite(
  input: Omit<FloorWriteItem, 'id' | 'status' | 'createdAt' | 'retryCount'>,
): FloorWriteItem {
  const item: FloorWriteItem = {
    ...input,
    id: `floor-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    status: 'pending',
    createdAt: new Date().toISOString(),
    retryCount: 0,
  };
  const next = [item, ...loadFloorWriteQueue().filter((q) => q.status === 'pending')];
  saveFloorWriteQueue(next);
  return item;
}

export function pendingFloorWriteCount(): number {
  return loadFloorWriteQueue().filter((q) => q.status === 'pending').length;
}

export function updateFloorWriteItem(id: string, patch: Partial<FloorWriteItem>): void {
  saveFloorWriteQueue(
    loadFloorWriteQueue().map((item) => (item.id === id ? { ...item, ...patch } : item)),
  );
}

export function clearSyncedFloorWrites(): void {
  saveFloorWriteQueue(
    loadFloorWriteQueue().filter((q) => q.status === 'pending' || q.status === 'failed'),
  );
}
